<template>
  <div style="padding-bottom: 100px">
    <!-- <header-title :Title="'工作台'"></header-title> -->
    <div class="tui-workList">
      <el-row
        :gutter="20"
        style="width: 100%"
        v-for="(item, index) in workList"
        :key="index"
      >
        <div class="tui-TypeName">{{ item.TypeName }}</div>
        <el-col :span="6" v-for="(aa, keys) in item.List" :key="keys">
          <div
            class="tui-workItem"
            @click="onClickOpenLink(aa)"
            @mouseenter="mouseOver(aa)"
            @mouseleave="mouseLeave(aa)"
          >
            <img :src="aa.Img" alt="" />
            <div>{{ aa.Name }}</div>

            <div
              class="tui-workDelete"
              v-show="aa.showIcon"
              @click.stop="onClickDeleteWork(aa)"
            >
              <i class="el-icon-delete"></i>
            </div>

            <div
              class="tui-workDelete"
              style="right: 0.525rem"
              v-show="aa.showIcon"
              @click.stop="onClickEdit(aa)"
            >
              <i class="el-icon-edit-outline"></i>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tui-workItem" @click="onClickAddWork(item)">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804173320_3125.png"
              alt=""
            />
            <div>添加更多</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 删除工作台 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleDelete"
      width="20%"
      center
      custom-class="tui-dialog"
    >
      <div class="tui-deleteCloud">
        <img
          src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804150425_1439.png"
          alt=""
        />
        <div>您确定要删除{{ form.Name }}吗？删除后需重新添加</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDelete = false" round>取 消</el-button>
        <el-button
          round
          type="primary"
          style="background: #27abf7"
          @click="onClickDeleteComfirm"
          >删 除</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增工作台 -->

    <el-dialog
      :title="Title"
      :visible.sync="dialogVisible"
      width="30%"
      custom-class="tui-dialog"
    >
      <div>
        <el-form
          :rules="rules"
          ref="ruleForm"
          :model="form"
          label-position="top"
        >
          <el-form-item label="名称:" prop="Name">
            <el-input v-model="form.Name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="网址:" prop="Url">
            <el-input v-model="form.Url" placeholder="请输入网址"></el-input>
          </el-form-item>
          <el-form-item label="LOGO:" prop="Img">
            <el-upload
              class="avatar-uploader"
              action="/api/img/UploadImg"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.Img" :src="form.Img" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="所属:" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio
                :label="cc.Type"
                v-for="(cc, nn) in workList"
                :key="nn"
                >{{ cc.TypeName }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" round @click="onClickAdd('ruleForm')">{{
          Title == "新增工作台" ? "添 加" : "编 辑"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerTitle from "../../components/headerTitle/headerTitle.vue";
import {
  Get_Hx_MyToolInfo,
  AddUpdate_Hx_MyToolInfo,
  Delete_Hx_MyToolInfo,
} from "../../api/api";

export default {
  components: {
    headerTitle,
  },
  data() {
    return {
      dialogVisibleDelete: false,
      dialogVisible: false,
      form: {
        Name: "",
        Url: "",
        Img: "",
        Id: 0,
        type: 3,
      },
      rules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        Url: [{ required: true, message: "请输入网址", trigger: "blur" }],
        Img: [{ required: true, message: "请选择图片", trigger: "change" }],
        type: [
          { required: true, message: "请选择默认所属", trigger: "change" },
        ],
      },
      workList: [],
      showIcon: false,
      Title: "",
      radioList: [],
    };
  },
  created() {
    this.Get_Hx_MyToolInfo();
  },
  methods: {
    mouseOver(item) {
      //console.log(item);
      item.showIcon = true;
    },
    mouseLeave(item) {
      item.showIcon = false;
    },
    // 删除
    async onClickDeleteComfirm() {
      let res = await Delete_Hx_MyToolInfo({
        ids: [this.form.Id],
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "删除成功",
        });
        this.Get_Hx_MyToolInfo();
        this.layoutData();
        this.dialogVisibleDelete = false;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    onClickOpenLink(item) {
      window.open(this.regHttp(item.Url), "_blank");
    },
    regHttp(v) {
      if (
        v.substr(0, 7).toLowerCase() == "http://" ||
        v.substr(0, 8).toLowerCase() == "https://"
      ) {
        return v;
      } else {
        return "http://" + v;
      }
    },
    // 重置
    layoutData() {
      this.form = {
        Name: "",
        Url: "",
        Img: "",
        Id: 0,
        type: 3,
      };
    },
    // 新增
    async onClickAdd(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await AddUpdate_Hx_MyToolInfo(this.form);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: this.Title == "新增工作台" ? "新增成功" : "修改成功",
            });
            this.Get_Hx_MyToolInfo();
            this.layoutData();
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    // 列表
    async Get_Hx_MyToolInfo() {
      let res = await Get_Hx_MyToolInfo();

      if (res.data.success) {
        res.data.response.forEach((cc) => {
          cc.List.forEach((aa) => (aa.showIcon = false));
        });
        this.workList = res.data.response;
      } else {
        this.workList = [];
      }
    },
    onClickDeleteWork(item) {
      this.form = item;
      this.dialogVisibleDelete = true;
    },
    // 编辑
    onClickEdit(item) {
      console.log(item);
      this.Title = "编辑工作台";
      this.form = {
        Name: item.Name,
        Url: item.Url,
        Img: item.Img,
        Id: item.Id,
        type: item.Type,
      };
      this.dialogVisible = true;
    },
    // 新增工作台
    onClickAddWork(item) {
      this.Title = "新增工作台";
      this.form = this.$options.data().form;
      this.form.type = item.Type;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      this.form.Img = res.response;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>
<style lang="less">
.tui-dialog {
  border-radius: 0.25rem;
  overflow: hidden;
}
.tui-TypeName {
  font-size: 20px;
  font-weight: 600;
  padding: 20px;
}
.el-dialog__header {
  background: url("http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-8/20220808145755_3530.png")
    no-repeat;
  padding: 30px 20px 30px;
  background-size: 100% 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 68px;
  height: 68px;
  line-height: 68px;
  text-align: center;
}
.avatar {
  width: 68px;
  height: 68px;
  display: block;
}
.tui-deleteCloud {
  display: flex;
  align-items: center;
  flex-direction: column;
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
  div {
    width: 3.625rem;
    font-size: 0.225rem;
    color: #333;
    padding-top: 0.375rem;
    line-height: 0.25rem;
  }
}
.tui-workList {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow-y: scroll;
  height: 10rem;
  // padding: 0 0.375rem;
  // .tui-workItem:hover {
  //   display: inline;
  // }
  .tui-workItem {
    // width: calc(100% / 5 - 0.4375rem);

    height: 1.25rem;
    background: #ffffff;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    padding-left: 0.3125rem;
    margin-right: 0.25rem;
    margin-bottom: 0.375rem;
    cursor: pointer;
    position: relative;
    .tui-workDelete {
      position: absolute;
      right: 0.125rem;
      top: 0.125rem;
      // display: none;
    }
    img {
      width: 0.625rem;
      height: 0.625rem;
      object-fit: contain;
      border-radius: 50%;
    }
    div {
      font-size: 0.25rem;
      color: #333;
      padding-left: 0.1875rem;
      font-weight: 600;
    }
  }
  .tui-workItem:nth-of-type(5n) {
    margin-right: 0;
  }
}
</style>